export default "__VITE_ASSET__BCTMUdju__";